module.exports = __webpack_public_path__ + "static/media/masterCard.63f359b2.svg";